// extracted by mini-css-extract-plugin
export default {"alert":"_2Ovi-"};